import React, { useState } from "react"
import moment from "moment"
import { useSelector } from "react-redux"
import { roleCheck } from "utils/index"
import { ADMIN, OPERATIONS } from "utils/constants"
import { getCurrentUser } from "../../reducers"
import UserBlockOutModal from "../Settings/UserDetails/components/UserBlockOutModal"

const BlockOutsTable = ({ blockOuts, currentDate, reloadData }) => {
  const currentUser = useSelector(getCurrentUser)
  const systemRole = currentUser?.attributes?.role
  const currentTeamRole = currentUser?.attributes?.current_team_role
  const isAdminOrOperations = roleCheck(systemRole, currentTeamRole, ADMIN) || roleCheck(systemRole, currentTeamRole, OPERATIONS)
  
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedBlockOut, setSelectedBlockOut] = useState(null)

  const sortedBlockOuts = blockOuts.slice().sort((a, b) => {
    if (a.user < b.user) return -1
    if (a.user > b.user) return 1
    return 0
  })

  const handleEditClick = (blockOut) => {
    const transformedBlockOut = {
      id: blockOut.id,
      attributes: {
        leaveType: blockOut.leave_type,
        startAt: blockOut.start_at,
        endAt: blockOut.end_at
      }
    }
    setSelectedBlockOut({ ...transformedBlockOut, user_id: blockOut.user_id })
    setShowEditModal(true)
  }

  const handleModalClose = () => {
    setShowEditModal(false)
    setSelectedBlockOut(null)
  }

  const handleModalReload = () => {
    if (reloadData) {
      reloadData()
    }
    setSelectedBlockOut(null)
    window.location.reload()
  }

  return (
    <div className="mb-2 surveyor-leave-section">
      <h6 className="mt-3 mb-0 d-inline text-muted">Surveyor On Leave</h6>
      <div className="table-responsive">
        <table className="table table-listing table-hover table-sm">
          <thead>
            <tr>
              <th>Surveyor</th>
              <th>Leave Type</th>
              <th>Start At</th>
              <th>End At</th>
              {isAdminOrOperations && <th></th>}
            </tr>
          </thead>
          <tbody>
            {
              sortedBlockOuts?.map(bo => {
                const startTime = moment(bo?.start_at, "DD/MM/YYYY hh:mm A")
                const endTime = moment(bo?.end_at, "DD/MM/YYYY hh:mm A")
                const currentDateStartTime = moment(`${currentDate} 08:00 AM`, "YYYY-MM-DD hh:mm A")
                const currentDateEndTime = moment(`${currentDate} 06:00 PM`, "YYYY-MM-DD hh:mm A")
                const displayStartTime = currentDateStartTime.isAfter(startTime) ? currentDateStartTime : startTime
                const displayEndTime = currentDateEndTime.isAfter(endTime) ? endTime : currentDateEndTime

                return (
                  <tr key={bo?.id} className="surveyor-leave-row">
                    <td>{bo?.user}</td>
                    <td>{bo?.leave_type}</td>
                    <td>{displayStartTime.format("DD/MM/YYYY hh:mm A")}</td>
                    <td>{displayEndTime.format("DD/MM/YYYY hh:mm A")}</td>
                    { isAdminOrOperations && (
                      <td>
                        <button
                          type="button"
                          className="btn btn-link p-0"
                          onClick={() => handleEditClick(bo)}
                          title="Edit Leave">
                          Edit
                        </button>
                      </td>
                    )}
                  </tr>
                )
              })
            }
          </tbody>
        </table>
      </div>
      { isAdminOrOperations && selectedBlockOut && (
        <UserBlockOutModal
          user={{ id: selectedBlockOut.user_id }}
          show={showEditModal}
          onHide={handleModalClose}
          reloadData={handleModalReload}
          editable={selectedBlockOut}
        />
      )}
    </div>
  )
}

export default BlockOutsTable
